var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _ = require("lodash");

var BaseResource = require("./BaseResource");

var toQueryString = function toQueryString(obj) {
  return _.map(obj, function (v, k) {
    return encodeURIComponent(k) + "=" + encodeURIComponent(v);
  }).join("&");
};

var Auth = /*#__PURE__*/function (_BaseResource) {
  "use strict";

  _inherits(Auth, _BaseResource);

  var _super = _createSuper(Auth);

  function Auth(client) {
    var _this;

    _classCallCheck(this, Auth);

    _this = _super.call(this, client);
    _this.path = "api/auth";
    return _this;
  }

  _createClass(Auth, [{
    key: "forgorPassword",
    value: function forgorPassword() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get(this.path + "/forgot-password?email=" + email, options);
    }
  }, {
    key: "passwordReset",
    value: function passwordReset() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._put(this.path + "/password-reset", data, options);
    }
  }, {
    key: "checkToken",
    value: function checkToken() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/check-token", data, options);
    }
  }, {
    key: "checkNovaUser",
    value: function checkNovaUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/check-nova-user", data, options);
    }
  }, {
    key: "sendEmailAddressVerificationEmail",
    value: function sendEmailAddressVerificationEmail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/send-email-address-verification-email", data, options);
    }
  }, {
    key: "sendPasswordResetEmail",
    value: function sendPasswordResetEmail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/send-password-reset-email", data, options);
    }
  }, {
    key: "seenDemo",
    value: function seenDemo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/seendemo", data, options);
    }
  }, {
    key: "signIn",
    value: function signIn() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/sign-in", data, options);
    }
  }, {
    key: "signInOauth",
    value: function signInOauth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/sign-in-oauth", data, options);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._put(this.path + "/profile", data, options);
    }
  }, {
    key: "updateMFA",
    value: function updateMFA() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._put(this.path + "/mfa", data, options);
    }
  }, {
    key: "updateMFAReminder",
    value: function updateMFAReminder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._put(this.path + "/mfa-reminder", data, options);
    }
  }, {
    key: "verifyEmail",
    value: function verifyEmail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/verify-email", data, options);
    }
  }, {
    key: "checkDevice",
    value: function checkDevice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._post(this.path + "/check-device", data, options);
    }
  }, {
    key: "verifyDevice",
    value: function verifyDevice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._put(this.path + "/verify-device", data, options);
    }
  }, {
    key: "getMe",
    value: function getMe() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._get(this.path + "/me", options);
    }
  }, {
    key: "getMyDevices",
    value: function getMyDevices() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._get("".concat(this.path, "/").concat(params && params.length > 0 ? "get-devices?".concat(toQueryString(params)) : "get-devices"), options);
    }
  }, {
    key: "isEmailConfigured",
    value: function isEmailConfigured() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._get(this.path + "/email-configured", options);
    }
  }]);

  return Auth;
}(BaseResource);

module.exports = Auth;